/* eslint-disable @typescript-eslint/no-explicit-any */
import { showNotification } from 'summon-ui'
import { useWriteContract, useSimulateContract } from 'wagmi'

type ReturnType = {
  mint: () => Promise<{ to: string; transactionHash: `0x${string}` }>
  errorMessage: string | null | undefined
  isLoading: boolean
  isContractReady: boolean
}

type Props = {
  functionName: string
  args: any[]
  contract: string
  abi: any
  isMainnet: boolean
}

const useMint = ({ functionName, args, contract, abi }: Props): ReturnType => {
  const { data, isPending: isSimulating } = useSimulateContract({
    address: contract as `0x${string}`,
    abi,
    functionName: functionName,
    args
  })
  const { writeContractAsync, isPending, error: contractWriteError } = useWriteContract()

  const mint = async () => {
    if (!isSimulating && data) {
      try {
        const tx = await writeContractAsync(data?.request)
        const txReceipt = {
          to: contract,
          transactionHash: tx
        }
        showNotification({
          variant: 'success',
          message: 'Congratulations! You have successfully minted'
        })
        return txReceipt
      } catch (error: any) {
        showNotification({
          variant: 'danger',
          message: 'Error minting'
        })
        const cause = error.cause.walk().message

        throw new Error('Error Minting: ' + cause)
      }
    } else {
      showNotification({
        variant: 'danger',
        message: 'Error minting'
      })

      throw new Error('Error Minting: writeAsync is not defined ')
    }
  }

  return {
    mint,
    errorMessage: contractWriteError?.message,
    isLoading: isPending,
    isContractReady: !!writeContractAsync
  }
}

export default useMint
